import AverageVelocity from "./MapContainer/AverageVelocity";
import BarChartWeeklyStatistics from "./MapContainer/BarChartWeeklyStatistics";
import React from "react";
import ChartTodayVelocity from "./MapContainer/ChartTodayVelocity";

const MapContainer = ({ token }) => {
  return (
    <div className="w-full h-full rounded-md">
      <div className="grid grid-flow-col justify-items-center rounded-md">
        <div
          className={`flex flex-col col-span-1 w-full h-full bg-white  border-2 rounded-md`}
        >
          <ChartTodayVelocity token={token} />
        </div>
        <div
          className={`flex flex-col col-span-1 w-full h-full bg-white  border-2 rounded-md`}
        >
          <BarChartWeeklyStatistics token={token} />
        </div>
        <div
          className={`flex flex-col col-span-2 w-full h-full bg-white  border-2 rounded-md`}
        >
          <AverageVelocity token={token} />
        </div>
      </div>
    </div>
  );
};

export default MapContainer;
